<template>
  <main class="main not-found">
    <div class="section">
      <div class="image">
        <img src="../../assets/images/img-fundanow-404@3x.png" alt="404" />
      </div>
      <div class="headline">
        <div class="headline__title">
          <h2>404 ERROR</h2>
        </div>
        <div class="headline__subtitle">
          <h4>죄송합니다.</h4>
          <p>요청한 페이지를 찾지 못했습니다.</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  created() {
    alert(location.href)
  }
}
</script>
